module.exports = __webpack_public_path__ + "static/media/seo.7276160b.svg";